module.exports = __webpack_public_path__ + "media/application/images/svgs/anchor-595de0353067110e463c3a7b9563da70.svg";